import {
    createColumnInput,
    createColumnSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import {
    createFieldInput,
    createFieldSelect,
    createFieldCheckbox, createFieldInputNumber
} from "../../../../../components/input/template-builder/template-builder.logic";
import store from "../../../../../store";

export const callFishingToolUnit = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "FISHING_TOOL_UNIT", value: searchQuery });

export const callDutyCalculator = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DUTY_CALCULATOR", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.fishingTool.nameTh"),
            dataIndex: "nameTh",
            customRender: ({ record }) => <div>{record.nameTh}</div>,
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.fishingTool.nameEn"),
            dataIndex: "nameEn",
            customRender: ({ record }) => <div>{record.nameTh}</div>,
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.fishingTool.refFishingToolUnit"),
            dataIndex: "refFishingToolUnit.value",
            customRender: ({ record }) => <div>{record.refFishingToolUnit?.value}</div>,
            inputProp: () => ({ list: callFishingToolUnit, optLabel: "value" }),
            search: { name: "refFishingToolUnit.id" }
        }),
    ]
    return columns
}

export const createFields = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}nameTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingTool.nameTh")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.nameTh,
                            "onUpdate:value": (value) => {
                                model.nameTh = value
                                model.isSave = true
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}nameEn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingTool.nameEn")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.nameEn,
                            "onUpdate:value": (value) => {
                                model.nameEn = value
                                model.isSave = true
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refFishingToolUnit`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingTool.refFishingToolUnit")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refFishingToolUnit,
                            "onUpdate:value": (value) => {
                                model.refFishingToolUnit = value
                                model.isSave = true
                            },
                            disabled: viewOnly,
                            list: callFishingToolUnit,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }) && model?.refParent != null,
                key: `${prefix}dutyPerUnit`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingTool.dutyPerUnit")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.dutyPerUnit,
                            "onUpdate:value": (value) => {
                                model.dutyPerUnit = value
                                model.isSave = true
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            // createFieldInput({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }) && model?.refParent != null,
            //     key: `${prefix}maximum`,
            //     colProp: () => ({ xs: 24, md: 12 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => `${i18n.global.t("model.fishingTool.maximum")}`,
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: model.maximum,
            //                 "onUpdate:value": (value) => {
            //                     model.maximum = value
            //                     model.isSave = true
            //                 },
            //                 disabled: viewOnly
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }) && model?.refParent != null,
                key: `${prefix}refCalDutyFrom`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingTool.refCalDutyFrom")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refCalDutyFrom,
                            "onUpdate:value": (value) => {
                                model.refCalDutyFrom = value
                                model.isSave = true
                            },
                            disabled: viewOnly,
                            list: callDutyCalculator,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && model?.refParent != null,
                key: `${prefix}isRequireInputInputWidth`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 4 }, wrapperCol: { xs: 20 }, colon: false }),
                label: () => `${i18n.global.t("model.fishingTool.isRequireInputWidth")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isRequireInputWidth,
                            "onUpdate:checked": (checked) => {
                                model.isRequireInputWidth = checked
                                model.isSave = true
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && model?.refParent != null,
                key: `${prefix}isMaximumWidth`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 4 }, wrapperCol: { xs: 20 }, colon: false }),
                label: () => `${i18n.global.t("model.fishingTool.isMaximumWidth")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isMaximumWidth,
                            "onUpdate:checked": (checked) => {
                                model.isMaximumWidth = checked
                                model.isSave = true
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && model?.refParent != null && model.isMaximumWidth,
                key: `${prefix}maximumWidth`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.fishingTool.maximumWidth"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.maximumWidth,
                            "onUpdate:value": (value) => {
                                model.maximumWidth = value
                                model.isSave = true;
                            },
                            disabled: viewOnly,
                            comma: true,
                            allowPrecision: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && model?.refParent != null,
                key: `${prefix}isRequireInputQty`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 4 }, wrapperCol: { xs: 20 }, colon: false }),
                label: () => `${i18n.global.t("model.fishingTool.isRequireInputQty")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isRequireInputQty,
                            "onUpdate:checked": (checked) => {
                                model.isRequireInputQty = checked
                                model.isSave = true
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && model?.refParent != null,
                key: `${prefix}isMaximumQty`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 4 }, wrapperCol: { xs: 20 }, colon: false }),
                label: () => `${i18n.global.t("model.fishingTool.isMaximumQty")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isMaximumQty,
                            "onUpdate:checked": (checked) => {
                                model.isMaximumQty = checked
                                model.isSave = true
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && model?.refParent != null && model.isMaximumQty,
                key: `${prefix}maximumWidth`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.fishingTool.maximumQty"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.maximumQty,
                            "onUpdate:value": (value) => {
                                model.maximumQty = value
                                model.isSave = true
                            },
                            disabled: viewOnly,
                            comma: true,
                            allowPrecision: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }) && model?.refParent != null,
                key: `${prefix}isCountLimitRequest`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 4 }, wrapperCol: { xs: 20 }, colon: false }),
                label: () => `${i18n.global.t("model.fishingTool.isCountLimitRequest")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isCountLimitRequest,
                            "onUpdate:checked": (checked) => {
                                model.isCountLimitRequest = checked
                                model.isSave = true;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}seq`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.fishingTool.seq")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.seq,
                            "onUpdate:value": (value) => {
                                model.seq = value
                                model.isSave = true
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    })
}